import React from "react";
import type {AuthService} from "./AuthService";
import {AuthContext} from "./AuthService";

export const useGuma = (): AuthService => {
    const context = React.useContext(AuthContext);
    if (!context) {
        throw new Error("GumaProvider context is undefined, please verify you are calling useAuth() as child of a <GumaProvider> component.");
    }
    return context;
};
